import UserBalancesPortfolioTable from 'src/components/UserBalancesPortfolioTable/UserBalancesPortfolioTable';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { getPoolName } from 'src/components/Earn/utils/earnProductUtils';
import { MAIN_POOL_ID } from '@drift/common';
import Tag from 'src/components/primitives/Tag/Tag';
import SkeletonValuePlaceholder from 'src/components/SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';
import useAppInitialLoad from 'src/hooks/app/useAppInitialLoad';

export default function PortfolioEarnBalancesTable() {
	const { isInitialLoading } = useAppInitialLoad();
	const isWalletConnected = useWalletIsConnected();
	const currentAccountExists = useDriftAccountStore(
		(s) => !!s.getCurrentUserAccount()
	);
	const poolId = useDriftAccountStore((s) => s.getCurrentUserAccount()?.poolId);

	const poolName = poolId ? getPoolName(poolId) : undefined;

	const isMainMarket = poolId === MAIN_POOL_ID;

	const tableTitle = (() => {
		if (isInitialLoading) {
			return <SkeletonValuePlaceholder className="h-5 w-20" loading />;
		}

		if (!isWalletConnected) {
			return 'Not connected';
		}

		if (!currentAccountExists) {
			return 'No account';
		}

		return poolName;
	})();

	const hasAccount = isWalletConnected && currentAccountExists;

	return (
		<div className="flex flex-col gap-y-lg">
			<div className="flex flex-col gap-y-xs">
				<h3 className="flex items-center gap-x-xs typo-t2 text-text-default">
					{tableTitle}

					{hasAccount && !isMainMarket && (
						<Tag className="bg-button-secondary-bg-hover text-text-default">
							Isolated Pool
						</Tag>
					)}
				</h3>
				{isMainMarket && (
					<p className="typo-b3 text-text-secondary">
						All assets earn yield even when used as collateral for trading or
						sat idle
					</p>
				)}
			</div>
			<div className="overflow-hidden rounded-sm">
				<UserBalancesPortfolioTable
					location="portfolio-page"
					expanded={false}
				/>
			</div>
		</div>
	);
}
